import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame", "error"]

  checkResponse(event) {
    const response = event.detail.fetchResponse
    if (!response.succeeded || !response.isHTML) this.failed(event)
  }

  failed(event) {
    if (event.target !== this.frameTarget) return

    event.preventDefault()
    this.frameTarget.hidden = true
    this.errorTarget.hidden = false
  }

  retry() {
    this.errorTarget.hidden = true
    this.frameTarget.hidden = false
    this.frameTarget.reload()
  }

  replaceOnMorph(event) {
    if (event.target !== this.frameTarget) return

    event.preventDefault()
    this.frameTarget.replaceWith(event.detail.newElement.cloneNode(true))
  }
}
